import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";

import Home from "./pages/Home";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsConditions from "./pages/TermsConditions";

// On route change, jump to the top (except when navigating to an in-page anchor).
function ScrollToTop() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) return;
    window.scrollTo(0, 0);
  }, [pathname, hash]);
  return null;
}

export default function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home />} />

        {/* Privacy Policy — canonical URL + the variants people type */}
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/privacy-policy.html" element={<PrivacyPolicy />} />

        {/* Terms & Conditions — canonical URL + the variants people type */}
        <Route path="/terms-conditions" element={<TermsConditions />} />
        <Route path="/terms-and-conditions" element={<TermsConditions />} />
        <Route path="/terms" element={<TermsConditions />} />
        <Route path="/tc" element={<TermsConditions />} />
        <Route path="/terms-conditions.html" element={<TermsConditions />} />

        {/* unknown paths fall back to the home page */}
        <Route path="*" element={<Home />} />
      </Routes>
    </BrowserRouter>
  );
}
